import { ContactFieldTypes, CustomField } from '@dev/ee-api/ee-api-models';
import { CUSTOM_FIELD_DEFAULT_FIELD_LENGTH } from '@/services/constants';
import { CustomFieldTypes } from '@/services/dictionaries/CustomFieldTypes';

export const getCustomFieldTypeOptions = (fieldType: string): CustomField => {
    if (fieldType === CustomFieldTypes.Birthday) {
        return {
            FieldType: ContactFieldTypes.DateTime,
            Length: 0
        }
    }
    if (fieldType === CustomFieldTypes.Consent) {
        return {
            FieldType: ContactFieldTypes.Boolean,
            Length: 0
        }
    } 
    return {
        FieldType: ContactFieldTypes.Text,
        Length: CUSTOM_FIELD_DEFAULT_FIELD_LENGTH
    }
}
